import AppRouter from 'common/AppRouter';
import {
  COLLABORATION_PROVIDERS_IDS_TO_NAMES,
  LOCAL_STORAGE_KEYS
} from 'common/constants/constants';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { OAuthProviders } from 'common/utils/assets.utils';
import { parseJwt } from 'common/utils/utils';
import _ from 'lodash';

const localStorageAccessor = BrowserStorageAccessor().local;

export const getButtonProps = ({
  hasAccount,
  isContributor,
  isMultipleOrgsContrib,
  history,
  ZendeskService,
  toggleModal
}) => {
  if (isMultipleOrgsContrib) {
    return {
      text: 'Contact support',
      action: () => {
        ZendeskService.openSupportRequest();
      }
    };
  }
  if (!isContributor) {
    return {
      text: 'Sign up to LinearB',
      action: () => {
        BrowserStorageAccessor().local.set(LOCAL_STORAGE_KEYS.LICENSE, 'team');
        history.push(AppRouter.REGISTER.path);
        toggleModal();
      }
    };
  }
  if (hasAccount) {
    return {
      text: 'or continue to your dashboard',
      action: () => {
        history.push(AppRouter.ROOT.path);
        toggleModal();
      }
    };
  }

  return {
    text: <div>Ask for an invitation</div>,
    action: async setIsRequested => {
      setIsRequested(true);
    }
  };
};

export const getMatchingProviders = connectedSensors =>
  _.chain(connectedSensors)
    .intersection(Object.keys(OAuthProviders))
    .reduce((acc, key) => {
      acc[key] = OAuthProviders[key];
      return acc;
    }, {})
    .filter(({ authIdentity }) => authIdentity)
    .value();

export const getCollaborationProviderName = () => {
  const token = localStorageAccessor.get(LOCAL_STORAGE_KEYS.LINK_ACCOUNT_TOKEN);
  try {
    const jwt = parseJwt(token);
    const name = COLLABORATION_PROVIDERS_IDS_TO_NAMES[jwt.sensor_id];
    return name;
  } catch (e) {
    return 'Slack';
  }
};
